import * as types from 'store/types'

const initialState = {
  loading: true,
  company: {
    members: [],
    tags: [],
    storageUtilized: 0 /** in bytes */
  },
  notifications: {
    unreadNotificationsCount: 0,
    mention: {
      pageNo: 0,
      total: 0,
      data: []
    },
    activity: {
      pageNo: 0,
      total: 0,
      data: []
    }
  },
  activities: [],
  recently_viewed: {
    pages: [],
    responses: []
  }
}

const companyReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.RESET_COMPANY: {
      return initialState
    }
    case types.SET_COMPANY: {
      return {
        ...state,
        company: { ...state.company, ...action.data.company },
        notifications: { ...state.notifications, unreadNotificationsCount: action.data.notifications.unreadNotificationsCount }
      }
    }
    case types.TOGGLE_COMPANY_LOADING: {
      return {
        ...state,
        loading: action.value
      }
    }
    case types.ADD_NOTIFICATIONS: {
      const { notifications } = state
      if (action.data.mention) {
        notifications.mention.pageNo = parseInt(action.data.mention.pageNo)
        notifications.mention.data = [...notifications.mention.data, ...action.data.mention.data]
        notifications.mention.total = parseInt(action.data.mention.total)
      } else if (action.data.activity) {
        notifications.activity.pageNo = parseInt(action.data.activity.pageNo)
        notifications.activity.data = [...notifications.activity.data, ...action.data.activity.data]
        notifications.activity.total = parseInt(action.data.activity.total)
      }
      return {
        ...state,
        notifications: { ...notifications }
      }
    }
    case types.SET_MARK_AS_READ_ON_CLICK: {
      const notifications = state.notifications
      for (const i in notifications.mention.data) {
        if (notifications.mention.data[i].notification_users_id === action.notiUser_id) {
          notifications.mention.data[i].is_read = true
          break
        }
      }
      for (const i in notifications.activity.data) {
        if (notifications.activity.data[i].notification_users_id === action.notiUser_id) {
          notifications.activity.data[i].is_read = true
          break
        }
      }
      return {
        ...state,
        notifications: { ...notifications }
      }
    }
    case types.SET_MARK_ALL_AS_READ_ON_CLICK: {
      const notifications = state.notifications
      for (const i in notifications.mention.data) {
        notifications.mention.data[i].is_read = true
      }
      for (const i in notifications.activity.data) {
        notifications.activity.data[i].is_read = true
      }
      return {
        ...state,
        notifications: { ...notifications }
      }
    }
    case types.SET_RECENT_ACTIVITIES: {
      return {
        ...state,
        activities: [...action.data]
      }
    }
    case types.SET_MEMBERS: {
      return {
        ...state,
        company: { ...state.company, members: action.data }
      }
    }
    case types.SET_STRIPE_CUSTOMER: {
      return {
        ...state,
        company: { ...state.company, stripe_id: action.data.id, stripe_customer: action.data }
      }
    }
    case types.SET_COMPANY_STORAGE_UTILIZED: {
      return {
        ...state,
        company: { ...state.company, storageUtilized: action.bytes }
      }
    }
    default:
      return state
  }
}
export default companyReducer
